bovoApp.
factory('CustomerGroup', ['$http', function($http) {
    return {
      all: function() {
        return $http.get('api/customer-groups');
      },
      get: function(id) {
        return $http.get('api/customer-group/' + id);
      },
      new: function(id) {
        return $http.get('api/new-customer-group');
      },
      delete: function(id) {
        return $http.delete('api/delete-customer-group/' + id);
      },
      save: function(data) {
        return $http.post('api/save-customer-group',data);
      },
      update: function(data) {
        return $http.post('api/update-customer-group',data);
      }
    };
}]);